var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ai-suggestion-box",
      on: { mouseenter: _vm.fnHoverEnter, mouseleave: _vm.fnHoverLeave }
    },
    [
      _c("div", { staticClass: "ai-suggestion-header" }, [
        _c("span", { staticClass: "ai-label" }, [_vm._v("AI")]),
        _vm._v(" "),
        _vm.data.confidence
          ? _c("span", { staticClass: "ai-confidence" }, [
              _vm._v(
                "\n      " +
                  _vm._s(Math.round(_vm.data.confidence * 100)) +
                  "%\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.intent
          ? _c("span", { staticClass: "ai-intent" }, [
              _vm._v(_vm._s(_vm.intentLabel) + " "),
              _c("span", { staticClass: "ai-intent-code" }, [
                _vm._v(_vm._s(_vm.data.intent))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.customerMessageTime
          ? _c("span", { staticClass: "ai-message-time" }, [
              _vm._v("\n      " + _vm._s(_vm.customerMessageTime) + "\n      "),
              _vm.data.used && _vm.data.used.isUsed
                ? _c("span", { staticClass: "ai-used-label" }, [
                    _vm._v("(ตอบแล้ว)")
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasJumpTarget
          ? _c(
              "span",
              {
                staticClass: "view-message-btn",
                attrs: { title: "ดูข้อความที่เกี่ยวข้อง" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.fnJumpToMessage($event)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-eye" }),
                _vm._v(" ดูข้อความลูกค้า\n    ")
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "ai-feedback-actions" }, [
          _c(
            "span",
            {
              staticClass: "feedback-btn feedback-incorrect",
              class: {
                active:
                  _vm.data.feedback && _vm.data.feedback.isCorrect === false
              },
              attrs: { title: "Incorrect" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.fnFeedbackIncorrect($event)
                }
              }
            },
            [_c("i", { staticClass: "fas fa-thumbs-down" })]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "feedback-btn close-btn",
              attrs: { title: "Close" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.fnClose($event)
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ai-suggestion-content" },
        [
          _c("div", { staticClass: "suggestion-dropdown" }, [
            _c(
              "span",
              {
                staticClass: "suggestion-chip suggestion-primary",
                attrs: { title: _vm.data.suggestedReply },
                on: { click: _vm.fnUseSuggestion }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.data.suggestedReply) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                class: { "has-add": _vm.hasMultipleSuggestions }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.fnSendImmediately(_vm.data.suggestedReply)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-paper-plane" }),
                    _vm._v(" ส่งทันที\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-item",
                    on: { click: _vm.fnUseSuggestion }
                  },
                  [
                    _c("i", { staticClass: "fas fa-edit" }),
                    _vm._v(" แก้ไข\n        ")
                  ]
                ),
                _vm._v(" "),
                _vm.hasMultipleSuggestions
                  ? _c(
                      "div",
                      {
                        staticClass: "dropdown-item dropdown-add",
                        on: {
                          click: function($event) {
                            return _vm.fnAppendSuggestion(
                              _vm.data.suggestedReply
                            )
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-plus" }),
                        _vm._v(" เพิ่มข้อความนี้\n        ")
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.data.alternativeReplies, function(alt, index) {
            return _c(
              "div",
              { key: index, staticClass: "suggestion-dropdown" },
              [
                _c(
                  "span",
                  {
                    staticClass: "suggestion-chip suggestion-alt",
                    attrs: { title: alt },
                    on: {
                      click: function($event) {
                        return _vm.fnUseAlternative(alt)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(alt) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    class: { "has-add": _vm.hasMultipleSuggestions }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function($event) {
                            return _vm.fnSendAlternativeImmediately(alt)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-paper-plane" }),
                        _vm._v(" ส่งทันที\n        ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function($event) {
                            return _vm.fnUseAlternative(alt)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-edit" }),
                        _vm._v(" แก้ไข\n        ")
                      ]
                    ),
                    _vm._v(" "),
                    _vm.hasMultipleSuggestions
                      ? _c(
                          "div",
                          {
                            staticClass: "dropdown-item dropdown-add",
                            on: {
                              click: function($event) {
                                return _vm.fnAppendSuggestion(alt)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fas fa-plus" }),
                            _vm._v(" เพิ่มข้อความนี้\n        ")
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c092e7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c092e7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AiSuggestion.vue
// module id = null
// module chunks = 